import { Badge, Button, Kbd } from '@personachat/ui';
import { LogOut, Search, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { AdminUser } from '../auth/session';

export function TopBar({ user, onSearch, onLogout }: { user: AdminUser; onSearch: () => void; onLogout: () => void }) {
  const mac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
  return (
    <header className="topbar">
      <button
        type="button"
        className="topbar__search"
        onClick={onSearch}
        aria-keyshortcuts={mac ? 'Meta+K' : 'Control+K'}
        data-tour="recherche"
      >
        <Search size={15} aria-hidden="true" />
        <span>Rechercher une élève, un écran…</span>
        <span className="topbar__keys" aria-hidden="true">
          <Kbd>{mac ? '⌘' : 'Ctrl'}</Kbd>
          <Kbd>K</Kbd>
        </span>
      </button>
      <div className="topbar__account" data-tour="mon-compte">
        <Badge tone={user.isSuperAdmin ? 'terracotta' : 'gold'}>{user.isSuperAdmin ? 'Super admin' : 'Admin'}</Badge>
        <Link className="topbar__email" to="/mon-compte" title="Mon compte : double authentification">
          {user.twoFactorEnabled && <ShieldCheck size={14} aria-label="Double authentification activée" />}
          {user.email}
        </Link>
        <Button variant="ghost" size="sm" icon={<LogOut size={15} aria-hidden="true" />} onClick={onLogout}>
          Se déconnecter
        </Button>
      </div>
    </header>
  );
}
